export default "__VITE_ASSET__C9k2sKLV__$_?no-inline__"